import React, {useEffect, useRef, useState} from "react";
import "../components/propertydetails/PropertyDetails.css";

/**
 * Auto-advancing property image gallery with manual prev/next controls and
 * keyboard arrow navigation; clicking the active image opens the zoom modal.
 */
export default function GalleryCarousel({
                                            images = [],
                                            autoplay = true,
                                            interval = 4000,
                                            onImageClick,
                                        }) {
    const [index, setIndex] = useState(0);
    const timerRef = useRef(null);

    useEffect(() => {
        if (!autoplay || images.length <= 1) return;
        timerRef.current = setInterval(() => {
            setIndex((i) => (i + 1) % images.length);
        }, interval);
        return () => clearInterval(timerRef.current);
    }, [autoplay, images.length, interval]);

    useEffect(() => {
        const count = images.length;
        const onKey = (e) => {
            if (!count) return;
            // Arrow keys typed into a form field (e.g. the brochure form) move the caret, not the gallery.
            if (e.target.closest?.("input, textarea, select, [contenteditable='true']")) return;
            if (e.key !== "ArrowLeft" && e.key !== "ArrowRight") return;
            clearInterval(timerRef.current);
            const step = e.key === "ArrowLeft" ? -1 : 1;
            setIndex((i) => (i + step + count) % count);
        };
        window.addEventListener("keydown", onKey);
        return () => window.removeEventListener("keydown", onKey);
    }, [images.length]);

    const prev = () => {
        clearInterval(timerRef.current);
        setIndex((i) => (i - 1 + images.length) % images.length);
    };

    const next = () => {
        clearInterval(timerRef.current);
        setIndex((i) => (i + 1) % images.length);
    };

    if (!images || images.length === 0) return null;

    return (
        <div className="gallery-root">

            <div className="gallery-main" onClick={() => onImageClick?.(index)}>
                <button
                    className="gallery-arrow left"
                    onClick={(e) => {
                        e.stopPropagation();
                        prev();
                    }}
                >
                    ‹
                </button>

                <div className="gallery-image-wrapper">
                    <img
                        src={images[index]}
                        alt={`Property view ${index + 1} of ${images.length}`}
                        className="gallery-image zoomable"
                        loading="lazy"
                        draggable="false"
                    />
                </div>

                <button
                    className="gallery-arrow right"
                    onClick={(e) => {
                        e.stopPropagation();
                        next();
                    }}
                >
                    ›
                </button>
            </div>
        </div>
    );
}
